import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';
import it from './locales/it.json';
import de from './locales/de.json';
import pt from './locales/pt.json';

// Namespace dédié à la landing page (`/`, `/fr`, `/en`…) : fichiers séparés pour
// ne pas gonfler les catalogues de l'app, fusionnés ici sous la clé `landing`.
import landingFr from './locales/landing/fr.json';
import landingEn from './locales/landing/en.json';
import landingEs from './locales/landing/es.json';
import landingIt from './locales/landing/it.json';
import landingDe from './locales/landing/de.json';
import landingPt from './locales/landing/pt.json';

// Namespace dédié aux autres pages publiques (contact, 404, tarifs, légal…) :
// même principe que `landing`, sous la clé `public`, pour ne pas alourdir les
// catalogues de l'app authentifiée.
import publicFr from './locales/public/fr.json';
import publicEn from './locales/public/en.json';
import publicEs from './locales/public/es.json';
import publicIt from './locales/public/it.json';
import publicDe from './locales/public/de.json';
import publicPt from './locales/public/pt.json';

import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
  resolveInitialLanguage,
} from './languages';

const initialLanguage = resolveInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: { ...fr, landing: landingFr, public: publicFr } },
      en: { translation: { ...en, landing: landingEn, public: publicEn } },
      es: { translation: { ...es, landing: landingEs, public: publicEs } },
      it: { translation: { ...it, landing: landingIt, public: publicIt } },
      de: { translation: { ...de, landing: landingDe, public: publicDe } },
      pt: { translation: { ...pt, landing: landingPt, public: publicPt } },
    },
    // La détection est faite en amont par `resolveInitialLanguage()` (URL →
    // localStorage → navigator.languages → fr) : plus fiable que le détecteur
    // générique, qui ne connaît pas nos préfixes d'URL.
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false, // React escape déjà nativement
    },
  });

/** Mémorise le choix et met à jour `<html lang>` pour l'accessibilité et le SEO. */
const persistLanguage = (language: string) => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Mode privé / stockage bloqué : la langue reste valable pour la session.
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language;
  }
};

persistLanguage(initialLanguage);
i18n.on('languageChanged', persistLanguage);

export default i18n;
